var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 94,
    viewBox: "0 0 120 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 100,
    height: 74,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 90,
    stroke: "#D2D6DF",
    strokeWidth: 3,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D2D6DF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7ADBB",
    d: "M72.5 50L107 81.226H38z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDC1CB",
    d: "M-6 81.226L31.75 39 69.5 81.226",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.604,
    cy: 20.604,
    r: 11.604,
    fill: "#F0F0F0",
    mask: "url(#b)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlaceholder);
export default __webpack_public_path__ + "static/media/ic-placeholder.c6cbec580f4212395b09da3e552d18cc.svg";
export { ForwardRef as ReactComponent };